import { render, staticRenderFns } from "./IotSettings.vue?vue&type=template&id=79d2117f"
import script from "./IotSettings.vue?vue&type=script&lang=js"
export * from "./IotSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports